import { render, staticRenderFns } from "./Ongoing.vue?vue&type=template&id=5b5461fc&scoped=true"
import script from "./Ongoing.vue?vue&type=script&lang=js"
export * from "./Ongoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5461fc",
  null
  
)

export default component.exports